module.exports = __webpack_public_path__ + "img/Cina.be224221.jpg";